import {ResultSubject, Text} from '../../../../styled';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import React from 'react';

export const getFileOwnership = (item:any) => {
  let ownership = `Owned by ${item.createdBy?.user.email}`;
  if (item.createdDateTime !== item.lastModifiedDateTime && item.lastModifiedBy) {
    ownership = `${ownership} | Last edited by ${item.lastModifiedBy.user.email}`
  }
  return ownership;
}

const FilesSnippet = ({ item }:any) => {
  const files = [{...item}];
  const ownership = getFileOwnership(item);
  return (
    <>
      <ResultSubject>
        <HighlightMarker>
          {item.title}
        </HighlightMarker>
      </ResultSubject>
      <FileAttachments files={files} />
      <Text variant="muted" size="small" >
        {ownership} | {item.date}
      </Text>
    </>
  )
}

export default FilesSnippet;